import React, { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import iconFilter from "@/assets/icon/icon_search.png";
import CustomModal from "../../../components/modal";
import "../Profile/index.less";
import "./index.less";
import {
	Button,
	Row,
	Col,
	Space,
	Table,
	Form,
	Input,
	Radio,
	Select,
	Spin,
	Tag,
	DatePicker,
	Pagination,
	Typography,
	Collapse,
} from "antd";
import sortData from "../../../utils/sorter";
import { effect, useStore } from "../../../utils/dva16";
import { customizeRenderEmpty } from "../../../utils/utils";
import formatDate from "@/utils/dateFormater";
import {
	EGet,
	EGetOne,
	NISBN,
	NGame,
	NGenre,
	NPlatform,
	EGetType,
	NOrganizationMulti,
	EGetCompany,
	NRegion,
	NLogin,
	EGetRegion,
	EGetArea,
	RSetState,
} from "../../../models/contants";
import { Line } from "@ant-design/charts";
import E from "../../../models/E";
import { Helmet } from "react-helmet";
import iconArrow from "@/assets/icon/arrow-down_mobile-table.png";
import reverseArrow from "@/assets/icon/arrow-down_mobile-table - reverse.png";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { reducer } from "../../../utils/dva16";

const { Option } = Select;
const { RangePicker } = DatePicker;
export default (props) => {
	const { Panel } = Collapse;
	const isMobile = useMediaQuery({ maxWidth: 767 }); // Mobile breakpoint
	const { history } = props;
	const { PlatformData } = useStore(NPlatform);
	const [searchValues, setSearchValues] = useState();
	const [filterValues, setFilterValues] = useState([]);
	const { OrganizationCompany } = useStore(NOrganizationMulti);
	const { gameSearch } = useStore(NGame);
	const { currentSubscribe, userInfo } = useStore(NLogin);
	const { areaList, regionList, commonAreaList } = useStore(NRegion);
	const [form] = Form.useForm();
	const { Text } = Typography;
	const [isBack, setIsBack] = useState(false);
	const [sortState, setSortState] = useState(null);
	let sortType = {
		ascend: "asc",
		descend: "desc",
	};
	const { ISBNData, ISBNTitleData, loading, isbnFilters } = useStore(NISBN);
	const ISBNLine = () => {
		const data = [];
		const [ISBNLineData, setISBNLineData] = useState({
			data,
			padding: "auto",
			xField: "datetime",
			yField: "monthCount",
			height: 290,
			appendPadding: 20,
			yAxis: {
				label: {
					// 数值格式化为千分位
					formatter: (v) =>
						`${v}`?.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
				},
			},
			seriesField: "lisenceArea",
		});
		useEffect(() => {
			if (ISBNTitleData?.totalALL) {
				ISBNLineData.data = ISBNTitleData?.totalALL || data;
				setISBNLineData(Object.assign({}, ISBNLineData));
			}
		}, [ISBNTitleData]);

		return <Line {...ISBNLineData} />;
	};
	// function findRegionType(arr) {
	// 	const updatedRegionArr = [];
	// 	areaList?.data?.forEach((item) => {
	// 		if (arr?.includes(item?.otherData)) {
	// 			updatedRegionArr?.push(item?.lookupValue);
	// 		}
	// 	});

	// 	form.setFieldsValue({
	// 		importRegion: Array.from(new Set(updatedRegionArr)),
	// 	});
	// }
	function findRegionType(arr) {
		const updatedRegionArr = [];
		areaList?.data?.forEach((item) => {
			if (arr?.includes(item?.otherData)) {
				updatedRegionArr?.push(item?.lookupValue);
			}
		});

		form.setFieldsValue({
			importRegion: Array.from(new Set(updatedRegionArr)),
		});
		setFormValues((prevValues) => ({
			...prevValues,
			["importRegion"]: Array.from(new Set(updatedRegionArr)),
		}));
	}
	const [showAllTags, setShowAllTags] = useState({});
	const toggleShowAll = (index) => {
		setShowAllTags((prevState) => ({
			...prevState,
			[index]: !prevState[index],
		}));
	};
	const [showAllTags2, setShowAllTags2] = useState({});
	const toggleShowAll2 = (index) => {
		setShowAllTags2((prevState) => ({
			...prevState,
			[index]: !prevState[index],
		}));
	};
	const columns = [
		{
			title: "Game",
			dataIndex: "gameId",
			key: "gameId",
			showSorterTooltip: false,
			align: "left",
			sortOrder: sortState?.field === "gameId" && sortState?.order,
			sorter: true,
			// sorter: (a, b) => {
			// 	if (a?.game?.gameEn && b?.game?.gameEn) {
			// 		return a?.game?.gameEn?.localeCompare(b?.game?.gameEn);
			// 	}
			// 	return 0;
			// },
			render: (text, record, index) => (
				<>
					<div className="Tabel_Company">
						<div className="Tabel_Company_Title">
							<p>
								<a
									className="a_style"
									href={`#/games/details/${record?.gameId}`}
								>
									{record?.game?.gameEn}
								</a>
							</p>
							<p>
								<a
									className="a_style"
									href={`#/games/details/${record?.gameId}`}
								>
									{record?.game?.gameCn}
								</a>
							</p>
						</div>
					</div>
				</>
			),
		},
		{
			title: "ISBN",
			showSorterTooltip: false, // Hide the default sorter tooltip
			dataIndex: "ISBN",
			align: "left",
			key: "ISBN",
			render: (text) => <span>{text ?? "-"}</span>,
			sortOrder: sortState?.field == "ISBN" && sortState?.order,
			sorter: (a, b) => a?.ISBN?.localeCompare(b?.ISBN),
		},
		{
			title: "License Type",
			dataIndex: "lisenceArea",
			key: "lisenceArea",
			align: "left",
			sortOrder: sortState?.field == "lisenceArea" && sortState?.order,
			sorter: (a, b) => a?.lisenceArea?.localeCompare(b?.lisenceArea),
			render: (text, record) => {
				return (
					<>
						<div>
							<span>{record?.lisenceArea}</span>
						</div>
					</>
				);
			},
		},

		{
			title: "Approval Date",
			dataIndex: "date",
			key: "date",
			showSorterTooltip: false, // Hide the default sorter tooltip
			align: "left",
			sortOrder: sortState?.field == "date" && sortState?.order,
			sorter: (a, b) => {
				const dateA = new Date(a?.date);
				const dateB = new Date(b?.date);
				return dateA - dateB;
			},
			render: (text, record, index) => {
				const date = new Date(record?.date);
				const formattedDate = formatDate(date);
				return <div>{record?.date ? formattedDate : ""} </div>;
			},
		},
		{
			title: "Licensed Platform",
			dataIndex: "licensedPlatform",
			showSorterTooltip: false, // Hide the default sorter tooltip
			key: "licensedPlatform",
			align: "left",
			sortOrder: sortState?.field == "licensedPlatform" && sortState?.order,
			sorter: (a, b) => a?.licensedPlatform?.localeCompare(b?.licensedPlatform),
			render: (text, record) => (
				<>
					{record?.licensedPlatform &&
						record?.licensedPlatform?.map((value, index) => {
							return <div key={index}>{value + "\n"}</div>;
						})}
				</>
			),
		},

		{
			title: "Publishing Unit",
			dataIndex: "publishingUnit",
			showSorterTooltip: false, // Hide the default sorter tooltip
			key: "publishingUnit",
			className: "custom-publisher-column",
			align: "center",
			sortOrder: sortState?.field == "publishingUnit" && sortState?.order,
			sorter: true,
			// sorter: (a, b) => a?.publishingUnit?.localeCompare(b?.publishingUnit),
			render: (text, record, index) => {
				const showAll = showAllTags[index] || false;
				return (
					<>
						{record?.withLicensee?.length > 0 ? (
							record?.withLicensee
								?.slice(0, showAll ? record.withLicensee.length : 3)
								?.map((value, index) => {
									return (
										<Tag
											className="purbleTag"
											key={index}
											onClick={() => {
												history.push(`/organizations/details/${value?.id}`);
											}}
										>
											{value?.name}
										</Tag>
									);
								})
						) : (
							<Tag
								className="purbleTag"
								onClick={() => {
									history.push(`/organizations/details/${value?.id}`);
								}}
							>
								{record?.publishingUnit}
							</Tag>
						)}

						{(record?.withLicensee?.length > 3 ||
							record?.withCompanys?.length > 3 ||
							record?.withTeams?.length > 3 ||
							record?.withPlatforms?.length > 3 ||
							record?.genres?.length > 3) && (
							<Tag className="greyTag" onClick={() => toggleShowAll(index)}>
								{showAll ? "Show less..." : "Show all..."}
							</Tag>
						)}
					</>
				);
			},
		},
		{
			title: "Operating Unit",
			dataIndex: "operatingUnit",
			className: "custom-publisher-column",
			key: "operatingUnit",
			align: "center",
			showSorterTooltip: false, // Hide the default sorter tooltip
			sortOrder: sortState?.field == "operatingUnit" && sortState?.order,
			sorter: true,
			// sorter: (a, b) => {
			// 	a?.withOperator?.[0]?.name &&
			// 		b?.withOperator?.[0]?.name &&
			// 		a?.withOperator?.[0]?.name?.localeCompare(b?.withOperator?.[0]?.name);
			// },
			render: (text, record, index) => {
				const showAll = showAllTags2[index] || false;
				return (
					<>
						{record?.withOperator
							?.slice(0, showAll ? record.withOperator.length : 3)
							?.map((value, index) => {
								return (
									<Tag
										className="purbleTag"
										key={index}
										onClick={() => {
											history.push(`/organizations/details/${value?.id}`);
										}}
									>
										{value?.name}
									</Tag>
								);
							})}
						{(record?.withOperator?.length > 3 ||
							record?.withCompanys?.length > 3 ||
							record?.withTeams?.length > 3 ||
							record?.withPlatforms?.length > 3 ||
							record?.genres?.length > 3) && (
							<Tag className="greyTag" onClick={() => toggleShowAll2(index)}>
								{showAll ? "Show less..." : "Show all..."}
							</Tag>
						)}
					</>
				);
			},
		},
		{
			title: "Import Area",
			dataIndex: "importArea",
			key: "importArea",
			showSorterTooltip: false, // Hide the default sorter tooltip
			align: "left",
			render: (text, record) => (
				<>
					{record?.importArea &&
						record?.lisenceArea == "Import" &&
						record?.importArea?.map((value, index) => {
							return <div key={index}>{value + "\n"}</div>;
						})}
				</>
			),
			sortOrder: sortState?.field == "importArea" && sortState?.order,
			sorter: (a, b) =>
				a?.importArea &&
				b?.importArea &&
				a?.importArea?.[0]?.localeCompare(b?.importArea?.[0]),
		},
		{
			title: "Import Region",
			showSorterTooltip: false, // Hide the default sorter tooltip
			dataIndex: "importRegion",
			key: "importRegion",
			align: "left",
			render: (text, record) => (
				<>
					{record?.importRegion &&
						record?.lisenceArea == "Import" &&
						record?.importRegion?.map((value, index) => {
							return <div key={index}>{value + "\n"}</div>;
						})}
				</>
			),
			sortOrder: sortState?.field == "importRegion" && sortState?.order,
			sorter: (a, b) =>
				a?.importRegion &&
				b?.importRegion &&
				a?.importRegion?.[0]?.localeCompare(b?.importRegion?.[0]),
		},
	];

	useEffect(() => {
		effect(NISBN, EGetOne, {});
		effect(NOrganizationMulti, EGetCompany, {
			page: 1,
			perPage: 10,
		});
		effect(NRegion, EGetRegion, { page: 1, perPage: 10 });
		effect(NPlatform, EGet, { page: 1, perPage: 25 });
		effect(NGame, EGetType, { page: 1, perPage: 10 });
		effect(NRegion, EGetArea, { page: 1, perPage: 200 });
		effect(NLogin, EGet, {});

		return () => {};
	}, []);

	useEffect(() => {
		let page = sessionStorage.getItem("isbnPage");
		let perPage = sessionStorage.getItem("isbnPageSize");
		if (isbnFilters) {
			setIsBack(true);
			form.setFieldsValue({ ...isbnFilters });
		}
		if (page && perPage) {
			effect(NISBN, EGet, { page, perPage, ...isbnFilters });
		} else {
			effect(NISBN, EGet, { page: 1, perPage: 10, ...isbnFilters });
		}
	}, []);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};
	const onFinish = (values) => {
		values.startDate = values?.startDate
			? moment(values?.startDate?._d)?.format("YYYY-MM-DD")
			: null;
		values.endDate = values?.endDate
			? moment(values?.endDate?._d)?.format("YYYY-MM-DD")
			: null;
		values.importArea = values.importArea && [
			...values?.importArea?.map((areaValue) => {
				return commonAreaList?.data?.find(
					(item) => item?.otherData === areaValue
				)?.id;
			}),
			...values.importArea,
		];
		const valuesArray = Object.values(values).filter(
			(val) =>
				val !== undefined &&
				val !== null &&
				!(Array.isArray(val) && val.length === 0)
		);
		setFilterValues(valuesArray);
		delete values?.date;
		setSearchValues(values);
		reducer(NISBN, RSetState, { isbnFilters: values });
		closeModal();
		effect(NISBN, EGet, {
			...values,
			page: 1,
			perPage: 10,
			field: sortState?.field,
			isDesc: sortState?.order && sortType[sortState?.order],
		});
	};

	const onSearchPlatform = (value) => {
		effect(NPlatform, EGet, { ...{ platform: value }, page: 1, perPage: 10 });
	};
	const onSearchCompany = (value) => {
		effect(NOrganizationMulti, EGetCompany, {
			name: value,
			page: 1,
			perPage: 10,
		});
	};
	const onSearchGame = (value) => {
		effect(NGame, EGetType, { ...{ name: value }, page: 1, perPage: 10 });
	};
	const onReset = () => {
		sessionStorage.setItem("isbnPage", 1);
		setFormValues([]);
		sessionStorage.setItem("isbnPageSize", 10);
		form.resetFields();
		setSortState(null);
		setFilterValues([]);
		closeModal();
		effect(NISBN, EGet, { page: 1, perPage: 10 });
	};

	const paginationLocale = {
		items_per_page: "per page",
	};
	const onPageChange = (page, perPage, sort) => {
		if (page && perPage) {
			effect(NISBN, EGet, {
				page: page,
				perPage: perPage,
				field: sortState && sortState?.field,
				isDesc: (sortState && sortState?.order) || null,
				...searchValues,
			});

			sessionStorage.setItem("isbnPage", page);
			sessionStorage.setItem("isbnPageSize", perPage);
		}
	};
	const [formValues, setFormValues] = useState({});

	// Handle form value changes
	const handleValuesChange = (changedValues) => {
		setFormValues((prevValues) => ({
			...prevValues,
			...changedValues,
		}));
	};

	// Reset field function
	const resetField = (fieldName) => {
		if (fieldName === "importArea") {
			findRegionType([]); // Clear region based on empty area
		}
		form.setFieldsValue({ [fieldName]: [] });
		setFormValues((prevValues) => ({
			...prevValues,
			[fieldName]: [],
		}));
		let values = form.getFieldsValue();
		setFilterValues(values);
	};
	const [activeKey, setActiveKey] = useState([]);

	const handleCollapseChange = (key) => {
		setActiveKey(key);
	};
	return (
		<div>
			<Helmet>
				<script
					dangerouslySetInnerHTML={{
						__html: `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-N9T2Q4PW');
                        `,
					}}
				/>
				{/* Google tag (gtag.js) */}
				<script
					async
					src="https://www.googletagmanager.com/gtag/js?id=G-6049TJDB50"
				></script>
				<script>
					{`
         				window.dataLayer = window.dataLayer || [];
        				function gtag(){dataLayer.push(arguments);}
          			gtag('js', new Date());
         				gtag('config', 'G-6049TJDB50');
        	`}
				</script>
			</Helmet>

			{userInfo?.type == "Client" ? (
				currentSubscribe?.module.hasOwnProperty("ISBN") &&
				currentSubscribe?.module["ISBN"]?.length > 0 ? (
					<Spin spinning={loading} size="large">
						<div>
							<p className="mainheader">ISBN</p>
							<div className="subHeader">
								Filter the knowledge base for ISBN data.
							</div>
						</div>
						<div className="searchBlog">
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<Form
									onValuesChange={handleValuesChange}
									form={form}
									onFinish={onFinish}
									className="searchFormCard"
								>
									{" "}
									<Row
										style={{
											display: "flex",
											// justifyContent: "flex-end",
											alignItems: "center",
										}}
									>
										<Form.Item name="keyWord" labelCol={{ span: 24 }}>
											<Input
												className="customInputBlog"
												placeholder="Search by Keyword"
											/>
										</Form.Item>
										<Button
											type="primary"
											htmlType="submit"
											className="applySearchBtn"
										>
											<img src={iconFilter} />
										</Button>
									</Row>
								</Form>
							</div>
							<CustomModal
								isBack={isBack}
								isModalOpen={isModalOpen}
								showModal={showModal}
								closeModal={closeModal}
								filterValues={filterValues}
								content={
									<>
										{" "}
										<Form
											onValuesChange={handleValuesChange}
											name="advanced_search"
											className="ant-advanced-search-form"
											labelCol={{ span: 8 }}
											form={form}
											onFinish={onFinish}
										>
											<Row gutter={24}>
												<Col span={24}>
													<Form.Item
														name="game"
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	GAME
																</Text>
																<Button
																	disabled={
																		!formValues.game ||
																		formValues.game.length === 0
																	}
																	className={
																		!formValues.game ||
																		formValues.game.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("game")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
													>
														<Select
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															showSearch
															filterOption={false}
															placeholder="Select"
															onSearch={debounce((value) => {
																onSearchGame(value);
															}, 100)}
														>
															{sortData(gameSearch?.data, "gameEn")?.map(
																(item, index) => {
																	return (
																		<Option key={index} value={item?.gameEn}>
																			{item?.gameEn}
																		</Option>
																	);
																}
															)}
														</Select>
													</Form.Item>
												</Col>
												<Col span={24}>
													<Form.Item
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	ISBN
																</Text>
																<Button
																	disabled={
																		!formValues?.ISBN ||
																		formValues?.ISBN?.length === 0
																	}
																	className={
																		!formValues?.ISBN ||
																		formValues?.ISBN?.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("ISBN")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
														name="ISBN"
													>
														<Input placeholder="Input here" />
													</Form.Item>
												</Col>
												<Col span={24}>
													<Form.Item
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	LICENCE TYPE
																</Text>
																<Button
																	disabled={
																		!formValues.lisenceArea ||
																		formValues.lisenceArea.length === 0
																	}
																	className={
																		!formValues.lisenceArea ||
																		formValues.lisenceArea.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("lisenceArea")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
														name="lisenceArea"
													>
														<Select
															getPopupContainer={(triggerNode) =>
																triggerNode?.parentNode
															}
															showArrow={true}
															placeholder="Select"
														>
															<Option value="Import">Import</Option>
															<Option value="Domestic">Domestic</Option>
														</Select>
													</Form.Item>
												</Col>

												<Col span={24}>
													<Form.Item
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	APPROVAL DATE
																</Text>
																<Form.Item shouldUpdate>
																	{({ getFieldValue }) => {
																		const startDate =
																			getFieldValue("startDate");
																		const endDate = getFieldValue("endDate");
																		const isDisabled = !startDate && !endDate;
																		return (
																			<Button
																				disabled={isDisabled}
																				className={
																					isDisabled ? "resetDisabled" : "reset"
																				}
																				onClick={() => {
																					form.resetFields([
																						"startDate",
																						"endDate",
																					]);
																				}}
																				type="secondary"
																				style={{
																					marginLeft: "auto",
																					cursor: "pointer",
																				}}
																			>
																				Reset
																			</Button>
																		);
																	}}
																</Form.Item>
															</div>
														}
													>
														<Row gutter={16}>
															<Col span={12}>
																<Form.Item name="startDate" noStyle>
																	<DatePicker
																		format="MMM DD, YYYY"
																		getPopupContainer={(triggerNode) =>
																			triggerNode.parentNode
																		}
																		style={{ width: "100%" }}
																		placeholder="Start Date"
																	/>
																</Form.Item>
															</Col>
															<Col span={12}>
																<Form.Item name="endDate" noStyle>
																	<DatePicker
																		format="MMM DD, YYYY"
																		getPopupContainer={(triggerNode) =>
																			triggerNode.parentNode
																		}
																		style={{ width: "100%" }}
																		placeholder="End Date"
																	/>
																</Form.Item>
															</Col>
														</Row>
													</Form.Item>
												</Col>
												<Col span={24}>
													<Form.Item
														name="licensedPlatform"
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	LICENSED PLATFORM
																</Text>
																<Button
																	disabled={
																		!formValues.licensedPlatform ||
																		formValues.licensedPlatform.length === 0
																	}
																	className={
																		!formValues.licensedPlatform ||
																		formValues.licensedPlatform.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("licensedPlatform")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
														rules={[
															{
																required: false,
																message: "Input something!",
															},
														]}
													>
														<Select
															showSearch
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															filterOption={(input, option) =>
																option?.children
																	?.toLowerCase()
																	.indexOf(input?.toLowerCase()) >= 0
															}
															placeholder="Select"
															onSearch={debounce((value) => {
																onSearchPlatform(value);
															}, 300)}
														>
															{sortData(PlatformData?.data, "platform")?.map(
																(record, index) => {
																	return (
																		<Option key={record?.id} value={record?.id}>
																			{record?.lookupValue}
																		</Option>
																	);
																}
															)}
														</Select>
													</Form.Item>
												</Col>

												<Col span={24}>
													<Form.Item
														name="publishingUnit"
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	PUBLISHING UNIT
																</Text>
																<Button
																	disabled={
																		!formValues.publishingUnit ||
																		formValues.publishingUnit.length === 0
																	}
																	className={
																		!formValues.publishingUnit ||
																		formValues.publishingUnit.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("publishingUnit")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
													>
														<Select
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															showSearch
															filterOption={false}
															placeholder="Select"
															onSearch={debounce((value) => {
																onSearchCompany(value);
															}, 300)}
														>
															{sortData(OrganizationCompany?.data)?.map(
																(item, index) => {
																	return (
																		<Option key={index} value={item?.name}>
																			{item?.name}
																		</Option>
																	);
																}
															)}
														</Select>
													</Form.Item>
												</Col>

												<Col span={24}>
													<Form.Item
														name="operatingUnit"
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	OPERATING UNIT
																</Text>
																<Button
																	disabled={
																		!formValues.operatingUnit ||
																		formValues.operatingUnit.length === 0
																	}
																	className={
																		!formValues.operatingUnit ||
																		formValues.operatingUnit.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("operatingUnit")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
													>
														<Select
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															showSearch
															filterOption={false}
															placeholder="Select"
															onSearch={debounce((value) => {
																onSearchCompany(value);
															}, 300)}
														>
															{sortData(OrganizationCompany?.data)?.map(
																(item, index) => {
																	return (
																		<Option key={item?.id} value={item?.id}>
																			{item?.name}
																		</Option>
																	);
																}
															)}
														</Select>
													</Form.Item>
												</Col>
												<Col span={24}>
													<Form.Item
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	IMPORT AREA
																</Text>
																<Button
																	disabled={
																		!formValues.importArea ||
																		formValues.importArea.length === 0
																	}
																	className={
																		!formValues.importArea ||
																		formValues.importArea.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("importArea")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
														name="importArea"
													>
														<Select
															mode="multiple"
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															id="select"
															placeholder="Select"
															showSearch
															onChange={(e) => {
																findRegionType(e);
															}}
															// onSearch={(value) => {
															// 	effect(NRegionArea, EGetArea, {
															// 		page: 1,
															// 		perPage: 200,
															// 		area: value,
															// 	});
															// }}
															filterOption={(input, option) =>
																option?.children
																	?.toLowerCase()
																	.indexOf(input?.toLowerCase()) >= 0
															}
														>
															{sortData(
																userInfo?.type === "Admin"
																	? areaList?.data
																	: areaList?.data?.filter((area) =>
																			currentSubscribe?.module[
																				"ISBN"
																			]?.includes(area?.lookupValue)
																	  ),
																"area"
															)?.map((record, index) => {
																return (
																	<Option
																		key={record?.id}
																		value={record?.otherData}
																	>
																		{record?.otherData}
																	</Option>
																);
															})}
														</Select>
													</Form.Item>
												</Col>
												<Col span={24}>
													<Form.Item
														name="importRegion"
														labelCol={{ span: 24 }}
														label={
															<div className="headBox">
																<Text className="label" type="secondary">
																	IMPORT REGION
																</Text>
																<Button
																	disabled={
																		!formValues.importRegion ||
																		formValues.importRegion.length === 0
																	}
																	className={
																		!formValues.importRegion ||
																		formValues.importRegion.length === 0
																			? "resetDisabled"
																			: "reset"
																	}
																	onClick={() => resetField("importRegion")}
																	type="secondary"
																	style={{
																		marginLeft: "auto",
																		cursor: "pointer",
																	}}
																>
																	Reset
																</Button>
															</div>
														}
													>
														<Select
															mode="multiple"
															getPopupContainer={(triggerNode) =>
																triggerNode.parentNode
															}
															showArrow
															placeholder="Select"
														>
															{sortData(
																userInfo?.type === "Admin"
																	? regionList
																	: regionList?.filter((region) =>
																			currentSubscribe?.module[
																				"ISBN"
																			]?.includes(region?.lookupValue)
																	  ),
																"region"
															)?.map((vo, index) => (
																<Option key={index} value={vo?.lookupValue}>
																	{vo?.lookupValue}
																</Option>
															))}
														</Select>
													</Form.Item>
												</Col>

												<Col span={24} style={{ textAlign: "right" }}>
													<Space>
														<Button
															type="primary"
															htmlType="submit"
															className="applyBtn"
														>
															Apply Now
														</Button>
														<Button
															type="default"
															onClick={onReset}
															className="resetBtn"
														>
															Reset All
														</Button>
													</Space>
												</Col>
											</Row>
										</Form>
									</>
								}
							/>
						</div>
						<div className="CompanyBox">
							<Row className="RowBox mt30">
								<Col span={24}>
									{!isMobile ? (
										<Table
											scroll={{ x: "max-content" }}
											dataSource={ISBNData?.data || []}
											columns={columns}
											className="CompanyTableBox"
											pagination={false}
											onChange={(pagination, filters, sort) => {
												const perPage = ISBNData?.perPage || 10; // Get the perPage from your data or default
												const currentPage = ISBNData?.page || 1; // Get the current page from your data or default

												setSortState(sort);
												effect(NISBN, EGet, {
													field: sort?.column && sort?.field,
													perPage: perPage,
													page: currentPage,
													...searchValues,
													isDesc:
														(sort?.column &&
															sort?.order &&
															sortType[sort?.order]) ||
														null,
												});
												sessionStorage.setItem("orgPage", pagination?.page);
												sessionStorage.setItem(
													"orgPageSize",
													pagination?.perPage
												);
											}}
										/>
									) : (
										<Collapse
											accordion
											activeKey={activeKey}
											onChange={handleCollapseChange}
											className="MobileList"
											expandIconPosition="right"
											expandIcon={({ isActive }) => (
												<div className="custom-arrow">
													<img
														src={isActive ? reverseArrow : iconArrow}
														alt="arrow"
													/>
												</div>
											)}
										>
											{ISBNData?.data.map((item) => (
												<Panel
													header={
														<div className="panel-header">
															<a
																className="a_style"
																href={`#/games/details/${item?.gameId}`}
															>
																<div>
																	<div>{item?.game?.gameEn}</div>
																	<div>{item?.game?.gameCn}</div>
																</div>
															</a>
														</div>
													}
													key={item.id}
												>
													<p>
														<Row>
															<Col className="head" span={12}>
																ISBN
															</Col>
															<Col className="text" span={12}>
																{item?.ISBN}
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																License Type
															</Col>
															<Col span={12}>
																<span>{item?.lisenceArea}</span>
															</Col>
														</Row>
														{/* <Row>
															<Col className="head" span={12}>
																Licensed Status
															</Col>
															<Col className="text" span={12}>
																<>
																	<div>
																		<span>
																			{item?.licensedStatus == 1
																				? "Active"
																				: item?.licensedStatus == 0
																				? "Inactive"
																				: ""}
																		</span>
																	</div>
																</>
															</Col>
														</Row> */}
														<Row>
															<Col className="head" span={12}>
																Approval Date
															</Col>
															<Col className="text" span={12}>
																<div>
																	{item?.date
																		? formatDate(new Date(item?.date))
																		: ""}{" "}
																</div>
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																Licensed Platform
															</Col>
															<Col className="text" span={12}>
																<>
																	{item?.licensedPlatform &&
																		item?.licensedPlatform?.map(
																			(value, index) => {
																				return (
																					<div key={index}>{value + "\n"}</div>
																				);
																			}
																		)}
																</>
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																Publishing Unit
															</Col>
															<Col className="text" span={12}>
																<>
																	{item?.withLicensee?.length > 0 ? (
																		item?.withLicensee?.map((value, index) => {
																			return (
																				<Tag
																					className="purbleTag"
																					key={index}
																					onClick={() => {
																						history.push(
																							`/organizations/details/${value?.id}`
																						);
																					}}
																				>
																					{value?.name}
																				</Tag>
																			);
																		})
																	) : (
																		<Tag
																			className="purbleTag"
																			onClick={() => {
																				history.push(
																					`/organizations/details/${value?.id}`
																				);
																			}}
																		>
																			{item?.publishingUnit}
																		</Tag>
																	)}
																</>
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																Operating Unit
															</Col>
															<Col className="text" span={12}>
																<>
																	{item?.withOperator?.map((value, index) => {
																		return (
																			<Tag
																				className="purbleTag"
																				key={index}
																				onClick={() => {
																					history.push(
																						`/organizations/details/${value?.id}`
																					);
																				}}
																			>
																				{value?.name}
																			</Tag>
																		);
																	})}
																</>
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																Import Area
															</Col>
															<Col className="text" span={12}>
																<>
																	{item?.importArea &&
																		item?.lisenceArea == "Import" &&
																		item?.importArea?.map((value, index) => {
																			return (
																				<div key={index}>{value + "\n"}</div>
																			);
																		})}
																</>
															</Col>
														</Row>
														<Row>
															<Col className="head" span={12}>
																Import Region
															</Col>
															<Col className="text" span={12}>
																<>
																	{item?.importRegion &&
																		item?.lisenceArea == "Import" &&
																		item?.importRegion?.map((value, index) => {
																			return (
																				<div key={index}>{value + "\n"}</div>
																			);
																		})}
																</>
															</Col>
														</Row>
													</p>
												</Panel>
											))}
										</Collapse>
									)}
								</Col>
							</Row>
							<Row style={{ padding: "10px 10px 0 10px", width: "100%" }}>
								<Col span={24}>
									{ISBNData?.error != 1009 && ISBNData?.total
										? ISBNData?.total && (
												<>
													<Pagination
														current={parseInt(ISBNData && ISBNData?.page) || 1}
														total={(ISBNData && ISBNData?.total) || 0}
														pageSize={ISBNData && ISBNData?.perPage}
														onChange={onPageChange}
														showSizeChanger
														showQuickJumper
														showTotal={(total, range) =>
															`${range[0]}-${range[1]} of ${total} items`
														}
														locale={paginationLocale}
														itemRender={(page, type, originalElement) => {
															if (type === "page") {
																return <span>{page}</span>;
															}
															return originalElement;
														}}
														className="custom-pagination"
													/>
												</>
										  )
										: ""}
								</Col>
							</Row>
						</div>
					</Spin>
				) : (
					// <></>
					customizeRenderEmpty()
				)
			) : (
				<Spin spinning={loading} size="large">
					<div>
						<p className="mainheader">ISBN</p>
						<div className="subHeader">
							Filter the knowledge base for ISBN data.
						</div>
					</div>
					<div className="searchBlog">
						<div
							style={{
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<Form
								onValuesChange={handleValuesChange}
								form={form}
								onFinish={onFinish}
								className="searchFormCard"
							>
								{" "}
								<Row
									style={{
										display: "flex",
										// justifyContent: "flex-end",
										alignItems: "center",
									}}
								>
									<Form.Item
										name="ISBN"
										labelCol={{ span: 24 }}
										className="inputBox"
									>
										<Input
											className="customInputBlog"
											placeholder="Search by ISBN"
										/>
									</Form.Item>
									<Button
										type="primary"
										htmlType="submit"
										className="applySearchBtn"
									>
										<img src={iconFilter} />
									</Button>
								</Row>
							</Form>
						</div>
						<CustomModal
							isBack={isBack}
							isModalOpen={isModalOpen}
							showModal={showModal}
							closeModal={closeModal}
							filterValues={filterValues}
							content={
								<>
									{" "}
									<Form
										onValuesChange={handleValuesChange}
										name="advanced_search"
										className="ant-advanced-search-form"
										labelCol={{ span: 8 }}
										form={form}
										onFinish={onFinish}
									>
										<Row gutter={24}>
											<Col span={24}>
												<Form.Item
													name="game"
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																GAME
															</Text>
															<Button
																disabled={
																	!formValues.game ||
																	formValues.game.length === 0
																}
																className={
																	!formValues.game ||
																	formValues.game.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("game")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
												>
													<Select
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														showArrow
														showSearch
														filterOption={false}
														placeholder="Select"
														onSearch={debounce((value) => {
															onSearchGame(value);
														}, 100)}
													>
														{sortData(gameSearch?.data, "gameEn")?.map(
															(item, index) => {
																return (
																	<Option key={index} value={item?.gameEn}>
																		{item?.gameEn}
																	</Option>
																);
															}
														)}
													</Select>
												</Form.Item>
											</Col>
											<Col span={24}>
												<Form.Item
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																ISBN
															</Text>
															<Button
																disabled={
																	!formValues?.ISBN ||
																	formValues?.ISBN?.length === 0
																}
																className={
																	!formValues?.ISBN ||
																	formValues?.ISBN?.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("ISBN")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
													name="ISBN"
												>
													<Input placeholder="Input here" />
												</Form.Item>
											</Col>
											<Col span={24}>
												<Form.Item
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																LICENCE TYPE
															</Text>
															<Button
																disabled={
																	!formValues.lisenceArea ||
																	formValues.lisenceArea.length === 0
																}
																className={
																	!formValues.lisenceArea ||
																	formValues.lisenceArea.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("lisenceArea")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
													name="lisenceArea"
												>
													<Select
														getPopupContainer={(triggerNode) =>
															triggerNode?.parentNode
														}
														showArrow
														placeholder="Select"
													>
														<Option value="Domestic">Domestic</Option>
														<Option value="Import">Import</Option>
													</Select>
												</Form.Item>
											</Col>

											<Col span={24}>
												<Form.Item
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																APPROVAL DATE
															</Text>
															<Form.Item shouldUpdate>
																{({ getFieldValue }) => {
																	const startDate = getFieldValue("startDate");
																	const endDate = getFieldValue("endDate");
																	const isDisabled = !startDate && !endDate;
																	return (
																		<Button
																			disabled={isDisabled}
																			className={
																				isDisabled ? "resetDisabled" : "reset"
																			}
																			onClick={() => {
																				form.resetFields([
																					"startDate",
																					"endDate",
																				]);
																			}}
																			type="secondary"
																			style={{
																				marginLeft: "auto",
																				cursor: "pointer",
																			}}
																		>
																			Reset
																		</Button>
																	);
																}}
															</Form.Item>
														</div>
													}
												>
													<Row gutter={16}>
														<Col span={12}>
															<Form.Item name="startDate" noStyle>
																<DatePicker
																	format="MMM DD, YYYY"
																	getPopupContainer={(triggerNode) =>
																		triggerNode.parentNode
																	}
																	style={{ width: "100%" }}
																	placeholder="Start Date"
																/>
															</Form.Item>
														</Col>
														<Col span={12}>
															<Form.Item name="endDate" noStyle>
																<DatePicker
																	format="MMM DD, YYYY"
																	getPopupContainer={(triggerNode) =>
																		triggerNode.parentNode
																	}
																	style={{ width: "100%" }}
																	placeholder="End Date"
																/>
															</Form.Item>
														</Col>
													</Row>
												</Form.Item>
											</Col>
											<Col span={24}>
												<Form.Item
													name="licensedPlatform"
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																LICENSED PLATFORM
															</Text>
															<Button
																disabled={
																	!formValues.licensedPlatform ||
																	formValues.licensedPlatform.length === 0
																}
																className={
																	!formValues.licensedPlatform ||
																	formValues.licensedPlatform.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("licensedPlatform")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
													rules={[
														{
															required: false,
															message: "Input something!",
														},
													]}
												>
													<Select
														showSearch
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														showArrow
														filterOption={(input, option) =>
															option?.children
																?.toLowerCase()
																.indexOf(input?.toLowerCase()) >= 0
														}
														placeholder="Select"
														onSearch={debounce((value) => {
															onSearchPlatform(value);
														}, 300)}
													>
														{sortData(PlatformData?.data, "platform")?.map(
															(record, index) => {
																return (
																	<Option key={record?.id} value={record?.id}>
																		{record?.lookupValue}
																	</Option>
																);
															}
														)}
													</Select>
												</Form.Item>
											</Col>

											<Col span={24}>
												<Form.Item
													name="publishingUnit"
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																PUBLISHING UNIT
															</Text>
															<Button
																disabled={
																	!formValues.publishingUnit ||
																	formValues.publishingUnit.length === 0
																}
																className={
																	!formValues.publishingUnit ||
																	formValues.publishingUnit.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("publishingUnit")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
												>
													<Select
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														showArrow
														showSearch
														filterOption={false}
														placeholder="Select"
														onSearch={debounce((value) => {
															onSearchCompany(value);
														}, 300)}
													>
														{sortData(OrganizationCompany?.data)?.map(
															(item, index) => {
																return (
																	<Option key={index} value={item?.name}>
																		{item?.name}
																	</Option>
																);
															}
														)}
													</Select>
												</Form.Item>
											</Col>

											<Col span={24}>
												<Form.Item
													name="operatingUnit"
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																OPERATING UNIT
															</Text>
															<Button
																disabled={
																	!formValues.operatingUnit ||
																	formValues.operatingUnit.length === 0
																}
																className={
																	!formValues.operatingUnit ||
																	formValues.operatingUnit.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("operatingUnit")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
												>
													<Select
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														showArrow
														showSearch
														filterOption={false}
														placeholder="Select"
														onSearch={debounce((value) => {
															onSearchCompany(value);
														}, 300)}
													>
														{sortData(OrganizationCompany?.data)?.map(
															(item, index) => {
																return (
																	<Option key={item?.id} value={item?.id}>
																		{item?.name}
																	</Option>
																);
															}
														)}
													</Select>
												</Form.Item>
											</Col>
											<Col span={24}>
												<Form.Item
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																IMPORT AREA
															</Text>
															<Button
																disabled={
																	!formValues.importArea ||
																	formValues.importArea.length === 0
																}
																className={
																	!formValues.importArea ||
																	formValues.importArea.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("importArea")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
													name="importArea"
												>
													<Select
														mode="multiple"
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														showArrow
														id="select"
														placeholder="Select"
														showSearch
														onChange={(e) => {
															findRegionType(e);
														}}
														filterOption={(input, option) =>
															option?.children
																?.toLowerCase()
																.indexOf(input?.toLowerCase()) >= 0
														}
													>
														{sortData(areaList?.data, "area")?.map(
															(record, index) => {
																return (
																	<Option
																		key={record?.id}
																		value={record?.otherData}
																	>
																		{record?.otherData}
																	</Option>
																);
															}
														)}
													</Select>
												</Form.Item>
											</Col>
											<Col span={24}>
												<Form.Item
													name="importRegion"
													labelCol={{ span: 24 }}
													label={
														<div className="headBox">
															<Text className="label" type="secondary">
																IMPORT REGION
															</Text>
															<Button
																disabled={
																	!formValues.importRegion ||
																	formValues.importRegion.length === 0
																}
																className={
																	!formValues.importRegion ||
																	formValues.importRegion.length === 0
																		? "resetDisabled"
																		: "reset"
																}
																onClick={() => resetField("importRegion")}
																type="secondary"
																style={{
																	marginLeft: "auto",
																	cursor: "pointer",
																}}
															>
																Reset
															</Button>
														</div>
													}
												>
													<Select
														mode="multiple"
														showArrow
														getPopupContainer={(triggerNode) =>
															triggerNode.parentNode
														}
														placeholder="Select"
													>
														{sortData(
															userInfo?.type === "Admin"
																? regionList
																: regionList?.filter((region) =>
																		currentSubscribe?.module["ISBN"]?.includes(
																			region?.lookupValue
																		)
																  ),
															"region"
														)?.map((vo, index) => (
															<Option key={index} value={vo?.lookupValue}>
																{vo?.lookupValue}
															</Option>
														))}
													</Select>
												</Form.Item>
											</Col>

											<Col span={24} style={{ textAlign: "right" }}>
												<Space>
													<Button
														type="primary"
														htmlType="submit"
														className="applyBtn"
													>
														Apply Now
													</Button>
													<Button
														type="default"
														onClick={onReset}
														className="resetBtn"
													>
														Reset All
													</Button>
												</Space>
											</Col>
										</Row>
									</Form>
								</>
							}
						/>
					</div>
					<div className="CompanyBox">
						<Row className="RowBox mt30">
							<Col span={24}>
								{!isMobile ? (
									<Table
										scroll={{ x: "max-content" }}
										dataSource={ISBNData?.data || []}
										columns={columns}
										className="CompanyTableBox"
										pagination={false}
										onChange={(pagination, filters, sort) => {
											const perPage = ISBNData?.perPage || 10; // Get the perPage from your data or default
											const currentPage = ISBNData?.page || 1; // Get the
											console.log(sort);
											setSortState(sort);
											effect(NISBN, EGet, {
												field: sort?.column && sort?.field,
												perPage: perPage,
												page: currentPage,
												...searchValues,
												isDesc:
													(sort?.column &&
														sort?.order &&
														sortType[sort?.order]) ||
													null,
											});
											sessionStorage.setItem("orgPage", pagination?.page);
											sessionStorage.setItem(
												"orgPageSize",
												pagination?.perPage
											);
										}}
									/>
								) : (
									<Collapse
										accordion
										activeKey={activeKey}
										onChange={handleCollapseChange}
										className="MobileList"
										expandIconPosition="right"
										expandIcon={({ isActive }) => (
											<div className="custom-arrow">
												<img
													src={isActive ? reverseArrow : iconArrow}
													alt="arrow"
												/>
											</div>
										)}
									>
										{ISBNData?.data.map((item) => (
											<Panel
												header={
													<div className="panel-header">
														<a
															className="a_style"
															href={`#/games/details/${item?.gameId}`}
														>
															<div>
																<div>{item?.game?.gameEn}</div>
																<div>{item?.game?.gameCn}</div>
															</div>
														</a>
													</div>
												}
												key={item.id}
											>
												<p>
													<Row>
														<Col className="head" span={12}>
															ISBN
														</Col>
														<Col className="text" span={12}>
															{item?.ISBN}
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															License Type
														</Col>
														<Col span={12}>
															<span>{item?.lisenceArea}</span>
														</Col>
													</Row>

													<Row>
														<Col className="head" span={12}>
															Approval Date
														</Col>
														<Col className="text" span={12}>
															<div>
																{item?.date
																	? formatDate(new Date(item?.date))
																	: ""}{" "}
															</div>
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															Licensed Platform
														</Col>
														<Col className="text" span={12}>
															<>
																{item?.licensedPlatform &&
																	item?.licensedPlatform?.map(
																		(value, index) => {
																			return (
																				<div key={index}>{value + "\n"}</div>
																			);
																		}
																	)}
															</>
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															Publishing Unit
														</Col>
														<Col className="text" span={12}>
															<>
																{item?.withLicensee?.length > 0 ? (
																	item?.withLicensee?.map((value, index) => {
																		return (
																			<Tag
																				className="purbleTag"
																				key={index}
																				onClick={() => {
																					history.push(
																						`/organizations/details/${value?.id}`
																					);
																				}}
																			>
																				{value?.name}
																			</Tag>
																		);
																	})
																) : (
																	<Tag
																		className="purbleTag"
																		onClick={() => {
																			history.push(
																				`/organizations/details/${value?.id}`
																			);
																		}}
																	>
																		{item?.publishingUnit}
																	</Tag>
																)}
															</>
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															Operating Unit
														</Col>
														<Col className="text" span={12}>
															<>
																{item?.withOperator?.map((value, index) => {
																	return (
																		<Tag
																			className="purbleTag"
																			key={index}
																			onClick={() => {
																				history.push(
																					`/organizations/details/${value?.id}`
																				);
																			}}
																		>
																			{value?.name}
																		</Tag>
																	);
																})}
															</>
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															Import Area
														</Col>
														<Col className="text" span={12}>
															<>
																{item?.importArea &&
																	item?.lisenceArea == "Import" &&
																	item?.importArea?.map((value, index) => {
																		return (
																			<div key={index}>{value + "\n"}</div>
																		);
																	})}
															</>
														</Col>
													</Row>
													<Row>
														<Col className="head" span={12}>
															Import Region
														</Col>
														<Col className="text" span={12}>
															<>
																{item?.importRegion &&
																	item?.lisenceArea == "Import" &&
																	item?.importRegion?.map((value, index) => {
																		return (
																			<div key={index}>{value + "\n"}</div>
																		);
																	})}
															</>
														</Col>
													</Row>
												</p>
											</Panel>
										))}
									</Collapse>
								)}
							</Col>
						</Row>
						<Row style={{ padding: "10px 10px 0 10px", width: "100%" }}>
							<Col span={24}>
								{ISBNData?.error != 1009 && ISBNData?.total
									? ISBNData?.total && (
											<>
												<Pagination
													current={parseInt(ISBNData && ISBNData?.page) || 1}
													total={(ISBNData && ISBNData?.total) || 0}
													pageSize={ISBNData && ISBNData?.perPage}
													onChange={onPageChange}
													showSizeChanger
													showQuickJumper
													showTotal={(total, range) =>
														`${range[0]}-${range[1]} of ${total} items`
													}
													locale={paginationLocale}
													itemRender={(page, type, originalElement) => {
														if (type === "page") {
															return <span>{page}</span>;
														}
														return originalElement;
													}}
													className="custom-pagination"
												/>
											</>
									  )
									: ""}
							</Col>
						</Row>
					</div>
				</Spin>
			)}
		</div>
	);
};
